import { ChangeEvent, useState } from "react"
import CustomInput from "../../component/CustomInput/CustomInput"
import Button from "../../component/button/button"
import "./Login.style.scss"
import { login } from "../../api/auth"
import { useNavigate } from "react-router-dom"
import { getProfile } from "../../api/profile"
import { clearStudentSession } from "../../api/studentAuth"

const Login = () => {
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    email: "",
    password: "",
  })
  const navigate = useNavigate()

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const validate = () => {
    let isValid = true
    const { email, password } = form
    if (!email || !password) {
      isValid = false
    }

    return isValid
  }
  const handleLogin = (e: any) => {
    e.preventDefault()
    const isValid = validate()

    if (!isValid) {
      return
    }

    setLoading(true)
    login(form)
      .then((res) => {
        const { access_token, refresh_token } = res?.data?.data
        clearStudentSession()
        localStorage.setItem("access_token", access_token)
        localStorage.setItem("refresh_token", refresh_token)

        setTimeout(() => {
          getProfile()
            .then((res) => {
              localStorage.setItem(
                "username",
                `${res?.data?.data?.first_name} ${res?.data?.data?.last_name}`
              )
              localStorage.setItem("email", `${res?.data?.data?.email} `)
              localStorage.setItem("userId", `${res?.data?.data?.id} `)
              // navigate('/')
              window.location.pathname = "/"
            })
            .catch((error) => {
              console.log(error)
            })
        }, 500)
      })
      .catch((err) => {
        const error = err?.response?.data?.message
        console.log({ error })

        setError(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <div className='content login'>
      <div className='login_container'>
        <h2 className='title'>Log In</h2>
        <p>Please enter your details to continue.</p>

        <form onSubmit={handleLogin}>
          <CustomInput
            placeholder='Please Enter your email'
            value={form.email}
            onChange={handleChange}
            name={"email"}
            error={error}
          />
          <CustomInput
            placeholder='*********'
            value={form.password}
            type='password'
            onChange={handleChange}
            name={"password"}
          />

          <Button
            text='Sign In'
            style={{
              marginTop: 12,
            }}
            type='secondary'
            buttonType='submit'
            isLoading={loading}
            loadingText={"Signing In..."}
          />
        </form>
        <div className='login_extra'>
          <div className='remember_me'>
            <input type='checkbox' name='rememberMe' id='rememberMe' />
            <label id='rememberMe'>Remember me</label>
          </div>

          <p
            className='forgot_password'
            onClick={() => {
              navigate("/reset-password")
            }}
          >
            Forgot Password?
          </p>
        </div>

        <p className='no_account'>
          Don't have an account? <span> Register here</span>
        </p>
      </div>
    </div>
  )
}

export default Login
